import React, { Fragment, useEffect, useMemo } from "react";
import "./index.scss";
import HeaderAction from "../components/HeaderAction";
import TitleLogo from "../components/TitleLogo";
import Reel from "../components/Reel";
import { useNavigate } from "react-router-dom";
import PATH from "../../../../config/PATH";
import {
  ID_TAB_MINI_GAME,
  TYPE_GIVE_PIECE,
  useNewYear2025Theme,
  useThadingyutTheme,
} from "../../../../helper/const";
import { useDispatch, useSelector } from "react-redux";
import { curStateAccount, curStateMiniGame } from "../../../../Redux/selector";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import ActionComponent from "../components/Action";
import MissionsList from "../components/MissionsList";
import ItemMission from "../components/MissionsList/ItemMission";
import bg1 from "../../../../assets/images/Mini-Game/bg-icon-mission.png";
import bg2 from "../../../../assets/images/Mini-Game/bg-icon-mission2.png";
import imgReelFooter from "../../../../assets/images/Mini-Game/img-reel-footer.png";
import imgReelFooterThadingyutTheme from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/img-reel-footer-thadingyut-2025-theme.png";
import imgReelFooterNewYear from "../../../../assets/images/Mini-Game/new-year-2025/1.png";
import ComponentLink from "../components/ComponentLink";
import iconPrizeCollection from "../../../../assets/images/Mini-Game/iconPrize.png";
import iconHome from "../../../../assets/images/Mini-Game/iconHome.png";
import logoCollectPiece from "../../../../assets/images/Mini-Game/logo-collect-piece.png";
import iconGift3d from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/icon-prize-3d.png";
import iconHome3d from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/icon-home-3d.png";
import iconGiftNewYear from "../../../../assets/images/Mini-Game/new-year-2025/icon-prize-link.png";
import iconHomeNewYear from "../../../../assets/images/Mini-Game/new-year-2025/icon-home.png";
import { useLocation } from "react-router-dom";
import {
  getDataMissionMiniGame,
  getDataSpinAwardMiniGame,
  setDataPopupError,
  setOpenPopupGivePiece,
  setOpenPopupLogin,
} from "../../../../Redux/futures/mini-game/action";
import EventMarquee from "../components/EventMarquee";
import { postDataApi } from "../../../../config/service";
import API_PATH from "../../../../config/API_PATH";
import styled from "styled-components";
import footerTree from "../../../../assets/images/Mini-Game/new-year-2025/footer-tree.png";
import lotusIcon from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/lotus-icon.png";

export default function MiniGameCollectPiece() {
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();

  const dataMiniGame = useSelector(curStateMiniGame);
  const selectorAccount = useSelector(curStateAccount);
  const dataMissionMini = dataMiniGame.dataMissionMini || [];

  useEffect(() => {
    // dispatch(getDataSpinAwardMiniGame());
    dispatch(getDataMissionMiniGame());
  }, []);

  useEffect(() => {
    if (location?.search !== "?invite-user") {
      return () => {};
    }

    const handleInviteUser = async () => {
      const dataApi = await postDataApi(API_PATH.miniGameAddInviteLink);

      // lỗi
      if (!dataApi?.success && dataApi?.errorMessage) {
        return dispatch(
          setDataPopupError({
            isOpen: true,
            message: dataApi?.errorMessage,
          })
        );
      }

      dispatch(
        setOpenPopupGivePiece({
          isShow: true,
          link: `http://reverseauction.com.mm/mini-game/invite-user/${dataApi?.data?.code}`,
          type: TYPE_GIVE_PIECE.inviteUser,
        })
      );
      dispatch(setOpenPopupLogin(false));
    };

    // if(data.type !== ID_INVITE_USER){

    if (_.isEmpty(selectorAccount?.userInfo) || !selectorAccount?.userInfo) {
      dispatch(setOpenPopupLogin(true));
      return () => {};
    }

    handleInviteUser();
    return () => {};
    // return
    // }
  }, [location?.search, selectorAccount?.userInfo]);

  const { dailyMissions = [], standardMissions = [] } = useMemo(() => {
    if (_.isEmpty(dataMissionMini)) {
      return {};
    }
    let dailyMissions = dataMissionMini.filter(
      (item) => item.is_one_time_daily
    );

    let standardMissions = dataMissionMini.filter(
      (item) => !item.is_one_time_daily
    );
    return { dailyMissions, standardMissions };
  }, [dataMissionMini]);

  const handleTopage = (id) => {
    navigate(`${PATH.MINI_GAME}/${id}`);
  };

  const dataLink = [
    {
      id: 1,
      srcImg: IS_EVENT_THADINGYUT_2025_THEME ? iconGift3d : iconPrizeCollection,
      action: () => handleTopage(ID_TAB_MINI_GAME.prizeCollection),
      content: t("mini_game.homepage.prize_collection"),
      height: 88,
    },
    {
      id: 2,
      srcImg: IS_EVENT_THADINGYUT_2025_THEME ? iconHome3d : iconHome,
      action: () => handleTopage(ID_TAB_MINI_GAME.home),
      content: t("mini_game.homepage.home"),
      height: 88,
    },
  ];

  const dataLinkNewYear = [
    {
      id: 1,
      srcImg: iconGiftNewYear,
      action: () => handleTopage(ID_TAB_MINI_GAME.prizeCollection),
      content: t("mini_game.homepage.prize_collection"),
      height: 88,
    },
    {
      id: 2,
      srcImg: iconHomeNewYear,
      action: () => handleTopage(ID_TAB_MINI_GAME.home),
      content: t("mini_game.homepage.home"),
      height: 88,
    },
  ]

  return (
    <div
      className={`container-minigame collect-piece ${
        IS_EVENT_THADINGYUT_2025_THEME
          ? "thadingyut-theme"
          : IS_EVENT_NEW_YEAR_2025_THEME
          ? "new-year-25-theme"
          : ""
      }`}
    >
      <div className='minigame-home-header position-relative'>
        <EventMarquee />
        <HeaderAction />
        <TitleLogo logo={logoCollectPiece} className='title-logo' />
        <ActionComponent />
        <Reel />
        {IS_EVENT_NEW_YEAR_2025_THEME ? null : (
          <img
            src={
              IS_EVENT_THADINGYUT_2025_THEME
                ? imgReelFooterThadingyutTheme
                : imgReelFooter
            }
            alt=''
            className='mini-game-img-reel-footer'
          />
        )}
      </div>
      <div className='mission-container-minigame__body position-relative'>
        {IS_EVENT_NEW_YEAR_2025_THEME && (
          <div className='mini-game-img-reel-footer-wrapper'>
            <img
              srcSet={`${imgReelFooterNewYear} 2x`}
              alt=''
              className='mini-game-img-reel-footer'
            />
          </div>
        )}
        {IS_EVENT_THADINGYUT_2025_THEME ||
        IS_EVENT_NEW_YEAR_2025_THEME ? null : (
          <>
            <img src={bg1} alt='' className='bg-mission-body' />
            <img src={bg2} alt='' className='bg2-mission-body' />
          </>
        )}

        <ComponentLink dataLink={
          IS_EVENT_NEW_YEAR_2025_THEME ? dataLinkNewYear : dataLink
        } />

        <MissionsList
          title={t("mini_game.homepage.daily_missions")}
          data={dailyMissions}
        >
          {dailyMissions?.map((item) => {
            return (
              <Fragment key={`dailay_${item.id}`}>
                <ItemMission data={item} isDaily />
              </Fragment>
            );
          })}
        </MissionsList>

        <MissionsList
          title={t("mini_game.standard_missions.title")}
          data={standardMissions}
        >
          {standardMissions.map((item) => {
            return (
              <Fragment key={`standar_${item.id}`}>
                <ItemMission data={item} />
              </Fragment>
            );
          })}
        </MissionsList>

        {IS_EVENT_THADINGYUT_2025_THEME && (
          <LotusIconContainer>
            <img src={lotusIcon} alt='Lotus Icon' />
          </LotusIconContainer>
        )}

        {IS_EVENT_NEW_YEAR_2025_THEME && (
          <div
            style={{
              position: "absolute",
              zIndex: 1,
              bottom: 0,
              left: 0,
              right: 0,
              width: "100%",
              pointerEvents: "none",
            }}
          >
            <img
              src={footerTree}
              alt='footer-tree'
              className='footer-tree-new-year-25-theme'
              style={{
                width: "100%",
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

const LotusIconContainer = styled.div`
  position: absolute;
  left: 0;
  transform: rotate(17deg) translate(-30%, -19%);
  z-index: 0;
  pointer-events: none;

  @media (max-width: 768px) {
    transform: rotate(17deg) translate(-30%, -13%);
    img {
      max-width: 85%;
    }
  }
`;
